/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  flexItem2: Item<'FlexItem'>;
  multiSeriesChart: Item<'MultiSeriesChart'>;
  flexItem1: Item<'FlexItem'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  emptySpacer: Item<'EmptySpacer'>;
  emptySpacer1: Item<'EmptySpacer'>;
} = {
  emptySpacer: {
    children: [],
    itemId: 'emptySpacer',
    parent: 'flexItem2',
    props: {},
    type: 'EmptySpacer',
  },
  emptySpacer1: {
    children: [],
    itemId: 'emptySpacer1',
    parent: 'flexItem',
    props: {},
    type: 'EmptySpacer',
  },
  flexItem: {
    children: ['emptySpacer1'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['multiSeriesChart'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      backgroundColor: 'paper',
      max: 600,
      min: 600,
      padding: {
        all: 16,
      },
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['emptySpacer'],
    itemId: 'flexItem2',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem2', 'flexItem1', 'flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {
      renderAs: 'columns',
    },
    type: 'FlexPanel',
  },
  multiSeriesChart: {
    children: [],
    itemId: 'multiSeriesChart',
    parent: 'flexItem1',
    props: {
      dsalias: 'test',
      labelAttribute: 'storeName',
      categoryAttribute: 'category',
      valueAttribute: 'sales',
      functionType: 'Sum',
      chartType: 'msbar3d',
      caption: {
        type: 'text',
        value: 'Split of Sales by Product Category',
      },
      subCaption: {
        type: 'text',
        value: 'In top 5 stores last month',
      },
      xAxisName: '',
      yAxisName: 'Sales (In USD)',
      showLegend: true,
      legendPosition: 'Bottom',
      showValues: false,
      use3DLighting: true,
      exportFileName: 'sales_by_category_chart',
    },
    type: 'MultiSeriesChart',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: JSON.stringify([
        {
          id: 'food-bc',
          storeName: 'Bakersfield Central',
          category: 'Food Products',
          sales: 17000,
        },
        {
          id: 'food-ggh',
          storeName: 'Garden Groove harbour',
          category: 'Food Products',
          sales: 19500,
        },
        {
          id: 'food-lat',
          storeName: 'Los Angeles Topanga',
          category: 'Food Products',
          sales: 12500,
        },
        {
          id: 'food-crd',
          storeName: 'Compton-Rancho Dom',
          category: 'Food Products',
          sales: 14500,
        },
        {
          id: 'food-dcs',
          storeName: 'Daly City Serramonte',
          category: 'Food Products',
          sales: 17500,
        },

        {
          id: 'nonfood-bc',
          storeName: 'Bakersfield Central',
          category: 'Non-Food Products',
          sales: 25400,
        },
        {
          id: 'nonfood-ggh',
          storeName: 'Garden Groove harbour',
          category: 'Non-Food Products',
          sales: 29800,
        },
        {
          id: 'nonfood-lat',
          storeName: 'Los Angeles Topanga',
          category: 'Non-Food Products',
          sales: 21800,
        },
        {
          id: 'nonfood-crd',
          storeName: 'Compton-Rancho Dom',
          category: 'Non-Food Products',
          sales: 19500,
        },
        {
          id: 'nonfood-dcs',
          storeName: 'Daly City Serramonte',
          category: 'Non-Food Products',
          sales: 11500,
        },
      ]),
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
